import { useMemo } from "react";

import type { HotelApplicationDataQueryQuery } from "@/lib/gql/__generated__/graphql";

import * as FormModel from "@/components/features/cancellation/model";
import type * as FormModelType from "@/components/features/cancellation/model/type";

import * as UseCase from "../use-update-billing-status";
import * as Converter from "./converter";

type Props = {
	hotelApplicationData: HotelApplicationDataQueryQuery;
};

export const useInitialized = ({ hotelApplicationData }: Props) => {
	const initInputModel: FormModelType.CancellationFormModel["InputModel"] = useMemo(
		() => Converter.serverModelToInputModelConverter({ hotelApplicationData }),
		[hotelApplicationData],
	);

	const queryData: FormModelType.CancellationFormModel["QueryData"] | undefined = useMemo(
		() => hotelApplicationData.billingStatus,
		[hotelApplicationData],
	);

	const { inputModel, viewModel, onSetViewModel } = FormModel.useCancellationFormModel(initInputModel);

	const { onCancellation } = UseCase.useCancellation(inputModel);

	return {
		queryData,
		viewModel,
		onSetViewModel,

		onCancellation,
	};
};
